const API_BASE = '/app/integrations/api'
const WEBHOOKS_BASE = '/app/integrations/webhooks'

export const publicApiPaths = {
  keys: API_BASE,
  createKey: `${API_BASE}/keys/create`,
  key: (id: string) => `${API_BASE}/keys/${id}`,
  editKey: (id: string) => `${API_BASE}/keys/${id}/edit`,
  webhooks: WEBHOOKS_BASE,
  createWebhook: `${WEBHOOKS_BASE}/create`,
  webhook: (id: string) => `${WEBHOOKS_BASE}/${id}`,
}
